export const checkIfIsExpired = (integration) => {
    if (integration?.expires_at == null) {
        return false;
    }
    return new Date(integration?.expires_at).getTime() < new Date().getTime()
}